import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import CoursePlayer from "./pages/CoursePlayer";
import Dashboard from "./pages/Dashboard";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import SSOEntry from "./pages/SSOEntry";

function PlatformRedirect() {
  React.useEffect(() => {
    const platformUrl =
      process.env.REACT_APP_MAAZ_PLATFORM_URL || "http://localhost:5174";

    window.location.replace(platformUrl);
  }, []);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#f4f6f8",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <div
        style={{
          background: "#fff",
          padding: "30px",
          borderRadius: "12px",
          boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
          textAlign: "center",
        }}
      >
        <strong>Opening MaAz Platform…</strong>
        <p style={{ color: "#666", marginBottom: 0 }}>
          Student sign-in is managed by MaAz Platform.
        </p>
      </div>
    </div>
  );
}


function StudentRoute({ children }) {
  const token = localStorage.getItem("token");
  return token ? children : <Navigate to="/" replace />;
}

function App() {
  return (
    <Router>
      <Routes>
        {/* Standalone LMS login is preserved for now. */}
        <Route path="/" element={<PlatformRedirect />} />

        {/* MaAz Platform → LMS one-time SSO entry */}
        <Route path="/sso" element={<SSOEntry />} />

        <Route
          path="/dashboard"
          element={
            <StudentRoute>
              <Dashboard />
            </StudentRoute>
          }
        />

        <Route
          path="/course/:id"
          element={
            <StudentRoute>
              <CoursePlayer />
            </StudentRoute>
          }
        />

        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />

        <Route path="*" element={<PlatformRedirect />} />
      </Routes>
    </Router>
  );
}

export default App;
